export default [
  {
    path: "/activity"
  },
  {
    path: "/activity/goods_seckill",
    name: "GoodsSeckill",
    meta: {
      title: "flash time",
      keepAlive: true,
      backgroundColor: "#ffffff"
    },
    component: () => import("@views/activity/GoodsSeckill.vue")
  },
  {
    path: "/activity/seckill_detail/:id?/:time",
    name: "SeckillDetails",
    meta: {
      title: "flash time detail",
      keepAlive: true
    },
    component: () => import("@views/activity/SeckillDetails.vue")
  },
  {
    path: "/raiders/list/:id",
    name: "RaidersIndex",
    meta: {
      title: "Raiders",
      keepAlive: true
    },
    component: () => import("@views/shop/raiders/list.vue")
  },
  {
    path: "/raiders/detail/:id",
    name: "GoodsCon",
    meta: {
      title: "Product points details",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/shop/raiders/detail.vue")
  },
  {
    path: "/raiders/submit/:id/:num",
    name: "GoodsCon",
    meta: {
      title: "Submit orders",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/shop/raiders/Submission.vue")
  },
  {
    path: "/raiders/PaymentStatus/:id",
    name: "GoodsCon",
    meta: {
      title: "Order status",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/shop/raiders/PaymentStatus.vue")
  },
];
//抢购
